import { render } from "./Tooltip.vue?vue&type=template&id=5dfd6f4a"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=5dfd6f4a&lang=css"
script.render = render

export default script